import React from 'react';

import { Header } from 'semantic-ui-react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

export interface Props {
  id: string;
  title?: string;
  description?: string;
}

const useStyles = makeStyles()((theme: Theme) => {
  return {
    header: {
      color: `${theme.palette.custom?.HEADER_BAR_TEXT_COLOR}!important`,
    },
    segmentHeader: {
      color: `${theme.palette.custom?.HEADER_BAR_TEXT_COLOR}!important`,
      backgroundColor: `${theme.palette.custom?.HEADER_BAR_BG_COLOR}!important`,
      opacity: '0.75',
      width: '100% !important',
    },
    description: {
      width: '100% !important',
    },
  };
});

function OhsStaticView(props: Props) {
  const { classes } = useStyles();
  return (
    <Box data-testid={props.id}>
      {props.title && (
        <Box className={`angularLayoutLabel angularLayoutLabelStatic ${classes.segmentHeader}`}>
          <Header as="h4" className={classes.header}>
            {props.title}
          </Header>
        </Box>
      )}
      {props.description && (
        <Box className={`angularLayoutLabel angularLayoutLabelStatic ${classes.description}`}>
          {props.description}
        </Box>
      )}
    </Box>
  );
}

OhsStaticView.defaultProps = {
  title: undefined,
  description: undefined,
};

export default OhsStaticView;
